import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import './index.scss';
export default function BlogShare({ title = '' }: { title: string }) {
    const { locale = 'us' } = useRouter();
    const [itemsB, setItemB] = useState<any[]>([]);
    useEffect(() => {
        const urlA = `${location.origin}${location.pathname}`;
        const listA = [
            {
                type: 'Facebook',
                href: `https://www.facebook.com/sharer.php?u=${urlA}`,
            },
            {
                type: 'Twitter',
                href: `https://twitter.com/intent/tweet?text=${title}&url=${urlA}&via=EcoFlow+${locale}+Blog`,
            },
            // {
            //     type: 'Linkedin',
            //     href: `https://www.linkedin.com/shareArticle?mini=true&url=${urlA}&title=${title}`,
            // },
            {
                type: 'Email',
                href: `mailto:?subject=${title}&body=${urlA}`,
            },
            // {
            //     type: 'Tumblr',
            //     href: `https://www.tumblr.com/share/link?url=${urlA}&name=${title}`,
            // },
            // {
            //     type: 'Telegram',
            //     href: `https://telegram.me/share/url?url=${urlA}&text=${title}`,
            // },
            // {
            //     type: 'Mix',
            //     href: `https://www.mix.com/add?url=${urlA}`,
            // },
            // {
            //     type: 'VK',
            //     href: `https://vk.com/share.php?url=${urlA}`,
            // },
            // {
            //     type: 'Digg',
            //     href: `https://www.digg.com/submit?url=${urlA}`,
            // },
        ];
        setItemB(listA);
    }, []);

    return (
        <div className={`blog-share`}>
            {itemsB.map((item: any, index: number) => {
                return (
                    <a key={index} href={item.href} className={`blog-share-item blog-share-item-${item.type}`}>
                        <div className="blog-share-item-title">{item.type}</div>
                    </a>
                );
            })}
        </div>
    );
}
